import React from 'react';
import CarddassList from '../components/Card/CarddassList';
import { CarddassContext } from '../contexts';

export default function AllCarddassList(props) {

    return (
        <React.Fragment>
            <div className="p-2">
                <h2>ビジネスマッチングカードダス一覧</h2>
                <p>クリックで拡大表示します。</p>
                <CarddassContext.Consumer>
                    {cards => <CarddassList cards={cards} searchable={true} showPerComplete={false} showAll={true} />}
                </CarddassContext.Consumer>
            </div>
        </React.Fragment>
    )
}